export default "__VITE_ASSET__DD3$K2EW__"